module.exports = __webpack_public_path__ + "img/logorinconpng5.d5f03a79.png";